import {
  FlatList,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import React from "react";
import { useTheme } from "react-native-paper";
interface FilterRowProps {
  title: string;
  list: string[];
  selected?: string;
  setFilter: (value: string) => void;
}

const FilterRow = ({ title, list, selected, setFilter }: FilterRowProps) => {
  const { colors } = useTheme();

  return (
    <View>
      <Text style={[styles.filterText, styles.filterHeader]}>{title}</Text>
      <FlatList
        data={list}
        horizontal
        renderItem={({ item }) => {
          const isActive = item === selected;
          return (
            <TouchableOpacity
              style={[
                styles.filterBtn,
                isActive && { backgroundColor: colors.primary },
              ]}
              onPress={() => setFilter(item)}
            >
              <Text style={[styles.filterText, isActive && { color: "#fff" }]}>
                {item}
              </Text>
            </TouchableOpacity>
          );
        }}
      />
    </View>
  );
};

export default FilterRow;

const styles = StyleSheet.create({
  filterBtn: {
    paddingVertical: 7,
    paddingLeft: 10,
    paddingRight: 5,
    backgroundColor: "#e1e8e8",
    borderRadius: 9,
    marginRight: 10,
    flexDirection: "row",
    alignItems: "center",
  },
  filterText: {
    color: "#6D7F80",
    fontSize: 16,
    fontWeight: "600",
    marginRight: 5,
  },
  filterHeader: {
    fontWeight: "700",
    marginVertical: 12,
  },
});
